
function EnppSignalAssignment() {
    /// <summary>
    /// This object provides js functions for the Widget.Enpp.EnppSignalAssignment* <br/>
    /// <br/>
    /// Author: AFU<br />
    /// Date: 28.7.2026<br />
    /// Copyright ©: EUDT GmbH 2026 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 28.7.2026                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// * - includes special functions for handling the extra items          *<br />
    /// **********************************************************************<br />
    /// </summary>

}

EnppSignalAssignment.prototype = new window.MSAssignment();

EnppSignalAssignment.prototype.loadItems = function (id) {
    /// <summary>
    /// Overload of the parent fucntion to load the items
    /// </summary>
    var me = this;

    try {

        window.MSAssignment.prototype.loadItems.call(me, id);

    } catch (ex) {
        me.writeError('loadItems', ex);
    }
};



EnppSignalAssignment.prototype.manualSorting = function (obj) {
    /// <summary>
    /// This function resorts the assigned signal list
    /// </summary>
    var me = this;

    try {

        if (obj.target.id === "lstTarget") {

            var lst = [];
            $.each(me.visual.find("#lstTarget .vc-list-item"), function () {
                lst.push($(this).data("id"));
            })

            //console.info(me);
            var params = JSON.parse(me.parameter);
            //console.info(params.id);
            var param = { EnppId: params.id, 'type': 3, 'LoggerId': me.blid, 'assID': me.assID, 'sorting': lst };


            window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, JSON.stringify(param),
                function (result) {
                    if (result !== true) {
                        me.showMessage(me.resources.err_saveData, true);
                        return false;
                    }
                    if (me.VCMQ_update_message.length > 0) {
                        _VCMQ.produce(me.visual, me.vcgid, me.VCMQ_update_message, '');
                    }

                    return true;
                });
        };
        return true;
    } catch (ex) {
        me.writeError('manualUpdate', ex);
        return false;
    }

};
